export const SET_NAVSTATE = 'SET_NAVSTATE'
export const SET_PERSONALCENTER = 'SET_PERSONALCENTER'
export const SET_USERNAME = 'SET_USERNAME'
export const SET_AVATAR = 'SET_AVATAR'
export const SET_NAV = 'SET_NAV'

